import React, { Component } from 'react';
import Axios from 'axios';
import './Management.css';

import Config from '../../../base/config/Config';
import Utils from '../../../base/Utils';
import Session from '../../../base/Session';

import Title from './../../components/title/Title';
import Description from './../../components/description/Description';
import Input from './../../components/input/Input';
import Button from './../../components/button/Button';
import HorizontalFlex from './../../components/horizontalFlex/HorizontalFlex';
import RequestLimits from './../../components/requestLimits/RequestLimits';
import Table from './../../components/table/Table';
import ProfilePic from './../../components/profilePic/ProfilePic';
import SmallText from './../../components/smallText/SmallText';
import Loading from './../../components/loading/Loading';

class Management extends Component {
    constructor(props) {
        super(props);
        
        this.loadCredentials();
        this.loadCollaboratorsList();
        this.loadWhitelistIPsList();
        
        this.state = {
            apiID: null,
            apiToken: null,
            generatingNewToken: false,
            tokenShow: false, 
            tokenCopied: false,
            
            collaborators: null,
            collaboratorHasContent: false,
            addingCollaborator: false,
            
            whitelistIPs: null,
            whitelistIPHasContent: false,
            addingWhitelistIP: false
        };
    }
    
    render() {
        var apiID = this.state.apiID;
        var apiToken = this.state.apiToken;
        var generatingNewToken = this.state.generatingNewToken;
        var tokenShow = this.state.tokenShow;
        var tokenCopied = this.state.tokenCopied;
        
        /*[
            { content: <ProfilePic src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRkSzr8E5RvU2plTX11P05001dGs36OhpAoVH4H97gwsataMg4j" 
            size="Medium" />, align: 'left' },
            { content: <font>Ricardo Carvalho <SmallText text="swonkie@swonkie.pt" /></font>, align: 'left' },
            { content: <SmallText text="Owner" />, align: 'right' },
            { content: '' }
        ],
        [
            { content: <ProfilePic src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRkSzr8E5RvU2plTX11P05001dGs36OhpAoVH4H97gwsataMg4j" 
            size="Medium" />, align: 'left' },
            { content: <font>Ricardo Carvalho <SmallText text="test@gmail.com" /></font>, align: 'left' },
            { content: <SmallText text="Collaborator" />, align: 'right' },
            { content: <Button text="Remove" type="Clean Normal" size="Small" /> }
        ]*/
        
        var collaborators = this.state.collaborators;
        
        if(collaborators !== null) {
            collaborators = {body: []};
            collaborators.body.push(this.state.collaborators.map((collaborator, index) => {
                return [
                    { content: <ProfilePic src={collaborator.photo} size="Medium" />, align: 'left' },
                    { content: collaborator.name, align: 'left' }, //<font>Ricardo Carvalho <SmallText text="test@gmail.com" /></font>
                    { content: <SmallText text="Collaborator" />, align: 'right' },
                    { content: <Button text="Remove" type="Clean Normal" size="Small" loading={collaborator.removing} onClick={() => {this.removeCollaborator(index)}} /> }
                ];
            }));
            
            if(collaborators.body[0][0]) collaborators.body = collaborators.body[0];
        }
        
        var addingCollaborator = this.state.addingCollaborator;
        var collaboratorHasContent = this.state.collaboratorHasContent;
        
        /*[
            { content: '127.0.0.1', align: 'left' },
            { content: <Button text="Remove" type="Clean Normal" size="Small" />, align: 'right' }
        ],
        [
            { content: '192.168.0.1', align: 'left' },
            { content: <Button text="Remove" type="Clean Normal" size="Small" />, align: 'right' }
        ]*/
        
        var whitelistIPs = this.state.whitelistIPs;
        
        if(whitelistIPs !== null) {
            whitelistIPs = {body: []};
            whitelistIPs.body.push(this.state.whitelistIPs.map((ip, index) => {
                return [
                    { content: ip.ip, align: 'left' },
                    { content: <Button text="Remove" type="Clean Normal" size="Small" loading={ip.removing} onClick={() => {this.removeWhitelistIP(index)}} />, align: 'right' }
                ];
            }));
            
            if(whitelistIPs.body[0][0]) whitelistIPs.body = whitelistIPs.body[0];
        }
        
        var addingWhitelistIP = this.state.addingWhitelistIP;
        var whitelistIPHasContent = this.state.whitelistIPHasContent;
        
        var tokenInputComponent = [
            <span style={{marginRight:'24px',width:'100%'}}><Input type={(tokenShow || apiToken === null) ? "text" : "password"} 
            getRef={(input) => this.tokenInput = input} state="ReadOnly" 
            value={(apiToken === null) ? "Loading..." : apiToken} /></span>,
            <Button text={(tokenShow) ? "Hide" : "Show"} type="Normal" size="Small" onClick={() => this.toggleTokenShow()} />,
            <Button text={(tokenCopied) ? "Copied" : "Copy"} type="Clean Normal" size="Small" onClick={() => this.copyToken()} />
        ];
        
        var addCollaboratorInputComponent = [
            <span style={{marginRight:'24px',width:'100%'}}><Input type="text" placeholder="Add Email"
            getRef={(input) => this.addCollaboratorInput = input}
            onChange={(input) => this.onChangeCollaboratorInput(input)} clearCallback={(callback) => { this.clearCollaboratorInput = callback }} /></span>,
            <Button text="Invite" type="Normal" state={(collaboratorHasContent) ? "Normal" : "Disabled"} 
            size="Small" loading={addingCollaborator} onClick={() => this.addCollaborator()} />
        ];
        
        var addWhitelistIPInputComponent = [
            <span style={{marginRight:'24px',width:'100%'}}><Input type="text" placeholder="Add IP"
            getRef={(input) => this.addWhitelistIPInput = input}
            onChange={(input) => this.onChangeWhitelistIPInput(input)} clearCallback={(callback) => { this.clearWhitespaceIPInput = callback }} /></span>,
            <Button text="Add" type="Normal" state={(whitelistIPHasContent) ? "Normal" : "Disabled"} 
            size="Small" loading={addingWhitelistIP} onClick={() => this.addWhitelistIP()} />
        ];
        
        return <div className="WidthLimit">
        <div className="Column-D1">
        <Title text="API ID" type="Underlined" size="Big" />
        <Description text="This is your API ID to be used for development and production of your app." />
        <Input value={(apiID === null) ? "Loading..." : apiID} state="ReadOnly" />
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1">
        <Title text="API Token" type="Underlined" size="Big" />
        <Description text="This is your API Token to be used for development and production of your app." />
        <HorizontalFlex components={tokenInputComponent} predominant="0" />
        </div>
        <div className="Spacer"></div>
        <div className="Column-D1">
        <Title text="API Limits" type="Normal" size="Medium" />
        <RequestLimits />
        <div className="Column-D1 NoMargin" style={{marginTop:'10px'}}>
        <Button text="Regenerate Token" type="Bad" size="Small" onClick={() => this.generateNewToken()} 
        loading={generatingNewToken} />
        <Button text="See token usage" type="Clean Normal" size="Small" to="/control-panel" />
        </div>
        </div>
        {
            (Session.getParams().isBrand) ?
            <span><div className="Spacer"></div>
            <div className="Column-D1">
            <Title text="Collaborators" type="Underlined" size="Big" />
            <Description text="Invite collaborators to allow them access to your Swonkie API token. 
            Users should be registered on Swonkie, new users need to create an account on Swonkie." />
            <div className="Column-D1_5 NoMargin" style={{margin: '10px 0px'}}>
            <HorizontalFlex components={addCollaboratorInputComponent} predominant="0" />
            </div>
            <div className="Column-D1 NoMargin" style={{textAlign:'center'}}>
            {(collaborators === null) ? 
                <span><br /><br /><Loading size="Medium" type="Fill" /></span> 
                : 
                <span>{(collaborators.body.length > 0 && collaborators.body[0].length > 0) ? 
                    <Table data={collaborators} />
                    : 
                    <span><br /><br /><Title text="There are no Collaborators in your team that can access the API." 
                    type="Normal" size="Small" /></span>
                }</span>
            }
            </div>
            </div></span>: ''
        }
        <div className="Spacer"></div>
        <div className="Column-D1">
        <Title text="Whitelist IP's" type="Underlined" size="Big" />
        <Description text="You can whitelist IP's to access your Swonkie API token. 
        If there is no whitelisted IP's added that means there is no access restrictions." />
        <div className="Column-D1_5 NoMargin" style={{margin: '10px 0px'}}>
        <HorizontalFlex components={addWhitelistIPInputComponent} predominant="0" />
        </div>
        <div className="Column-D1 NoMargin" style={{textAlign:'center'}}>
        {(whitelistIPs === null) ? 
            <span><br /><br /><Loading size="Medium" type="Fill" /></span> 
            : 
            <span>{(whitelistIPs.body.length > 0 && whitelistIPs.body[0].length) ? 
                <Table data={whitelistIPs} />
                : 
                <span><br /><br /><Title text={<font>There are no whitelisted IPs.<br />
                    <SmallText text="This means that everyone with the credentials can request to your account..." /></font>} 
                    type="Normal" size="Small" /></span>
                }</span>
            }
            </div>
            </div>
            <div className="Spacer"></div>
            <div className="Spacer"></div>
            <div className="Spacer"></div>
            </div>;
        }
        
        tokenInput = null;
        
        generateNewToken() {
            this.setState({generatingNewToken: true});
            
            Axios.put(Config.backendHost + "token", {withCredentials: true}).then((response) => {
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        data = data.data;
                        
                        this.setState({generatingNewToken: false, apiID: data.appId, apiToken: data.appToken});
                        return;
                    }
                }
                this.setState({generatingNewToken: false, apiID: "", apiToken: ""});
            }).catch((err) => { this.setState({generatingNewToken: false, apiID: "", apiToken: ""}); });
        }
        
        loadCredentials() {
            Axios.get(Config.backendHost + "token", {withCredentials: true}).then((response) => {
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        data = data.data;
                        
                        this.setState({apiID: data.appId, apiToken: data.appToken});
                        return;
                    }
                }
                this.setState({apiID: "", apiToken: ""});
            }).catch((err) => { this.setState({apiID: "", apiToken: ""}); });
        }
        
        toggleTokenShow(forceState) {
            this.setState({
                tokenShow: forceState || !this.state.tokenShow
            });
        }
        
        copyToken() {
            this.toggleTokenShow(true);
            setTimeout(() => {
                this.tokenInput.select();
                document.execCommand('copy');
                this.setState({
                    tokenCopied: true 
                });
                
                setTimeout(() => {
                    this.toggleTokenShow(false);
                    this.tokenInput.blur();
                    this.setState({
                        tokenCopied: false 
                    });
                }, 2000);
            }, 100);
        }
        
        loadCollaboratorsList() {
            Axios.get(Config.backendHost + "manage/members", {withCredentials: true}).then((response) => {
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        data = data.data;
                        
                        this.setState({collaborators: data});
                        return;
                    }
                }
                this.setState({collaborators: []});
            }).catch((err) => { this.setState({collaborators: []}); });
        }
        
        addCollaboratorInput = null;
        clearCollaboratorInput = function(){ };
        
        onChangeCollaboratorInput(input) {
            var value = input.value.toString().trim();
            
            this.setState({collaboratorHasContent: (value !== '' && Utils.validateEmail(value))});
        }
        
        addCollaborator() {
            var value = this.addCollaboratorInput.value.trim();
            this.setState({addingCollaborator: true});
            this.clearCollaboratorInput();
            
            Axios.post(Config.backendHost + "manage/members", {email: value}, {withCredentials: true}).then((response) => {
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        data = data.data;
                        
                        var collaborators = this.state.collaborators;
                        collaborators.push(data);
                    }
                }
                
                this.clearCollaboratorInput();
                this.setState({collaborators: collaborators, addingCollaborator: false});
            }).catch((err) => {
                this.setState({addingCollaborator: false});
            });
        }
        
        removeCollaborator(index) {
            var collaborators = this.state.collaborators;
            collaborators[index].removing = true;
            
            Axios.delete(Config.backendHost + "manage/members", {idUser: collaborators[index].id}, {withCredentials: true}).then((response) => {
                collaborators[index].removing = false;
                
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        collaborators.splice(index, 1);
                    }
                }
                this.setState({collaborators: collaborators});
            }).catch((err) => { 
                collaborators[index].removing = false;
                this.setState({collaborators: collaborators});
            });
        }
        
        loadWhitelistIPsList() {
            Axios.get(Config.backendHost + "manage/whitelist", {withCredentials: true}).then((response) => {
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        data = data.data;
                        
                        data = data.map((ip) => {
                            return {ip: ip};
                        });
                        
                        this.setState({whitelistIPs: data});
                        return;
                    }
                }
                this.setState({whitelistIPs: []});
            }).catch((err) => { this.setState({whitelistIPs: []}); });
        }
        
        addWhitelistIPInput = null;
        clearWhitespaceIPInput = function(){ };
        
        onChangeWhitelistIPInput(input) {
            var value = input.value.toString().trim();
            
            this.setState({whitelistIPHasContent: (value !== '' && Utils.validateIP(value))});
        }
        
        addWhitelistIP() {
            var value = this.addWhitelistIPInput.value.trim();
            
            var whitelistIPs = this.state.whitelistIPs;
            var hasIP = false;
            
            whitelistIPs.map((ip) => {
                if(ip.ip === value) hasIP = true;
                
                return ip;
            });
            
            if(!hasIP) {
                this.setState({addingWhitelistIP: true});
                Axios.post(Config.backendHost + "manage/whitelist", {ip: value}, {withCredentials: true}).then((response) => {
                    if(Utils.checkResponse(response)) {
                        var data = response.data;
                        
                        if(data.status === 'success') {
                            data = data.data;
                            
                            var whitelistIPs = this.state.whitelistIPs;
                            
                            whitelistIPs.push({ip: data});
                        }
                    }
                    
                    this.clearWhitespaceIPInput();
                    this.setState({whitelistIPs: whitelistIPs, addingWhitelistIP: false});
                }).catch((err) => {
                    this.setState({addingWhitelistIP: false});
                });
            }
        }
        
        removeWhitelistIP(index) {
            var whitelistIPs = this.state.whitelistIPs;
            whitelistIPs[index].removing = true;
            
            this.setState({whitelistIPs: whitelistIPs});
            
            Axios.delete(Config.backendHost + "manage/whitelist", {params: {ip: whitelistIPs[index].ip}}, {withCredentials: true}).then((response) => {
                whitelistIPs[index].removing = false;
                
                if(Utils.checkResponse(response)) {
                    var data = response.data;
                    
                    if(data.status === 'success') {
                        whitelistIPs.splice(index, 1);
                    }
                }
                this.setState({whitelistIPs: whitelistIPs});
            }).catch((err) => { 
                whitelistIPs[index].removing = false;
                this.setState({whitelistIPs: whitelistIPs});
            });
        }
    }
    
    export default Management;
    